module.exports = __webpack_public_path__ + "img/logo-iti.0b103755.svg";